import { isEnabled } from 'features/fflip-helpers';

const fflipConfig = {
  criteria: [],
  features: [
    {
      id: 'lawyerIndexation',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_INDEXATION_LAWYER),
    },
    {
      id: 'managerIndexation',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_INDEXATION_MANAGER),
    },
    {
      id: 'courtManagerAssignment',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_COURT_MANAGER_ASSIGMEMNT),
    },
    {
      id: 'lawyerAssignment',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_LAWYER_ASSIGMEMNT),
    },
    {
      id: 'lawyerJudgementAdd',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_LAWYER_JUDGEMENT_ADD),
    },
    {
      id: 'opposingParty',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_OPPOSING_PARTY),
    },
    {
      id: 'managerJudgementAdd',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_MANAGER_JUDGEMENT_ADD),
    },
    {
      id: 'searchBar',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_SEARCH_BAR),
    },
    {
      id: 'expertReport',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_EXPERT_REPORT),
    },
    {
      id: 'legalProceedingStep',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_LEGAL_PROCEEDING_STEP),
    },
    {
      id: 'suedParty',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_SUED_PARTY),
    },
    {
      id: 'judgementOnMerits',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_JUDGEMENT_ON_MERITS),
    },
    {
      id: 'judgementAppeal',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_JUDGEMENT_APPEAL),
    },
    {
      id: 'expertReportSagisEvaluation',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_EXPERT_REPORT_SAGIS_EVALUATION,
      ),
    },
    {
      id: 'mixedClaim',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_MIXED_CLAIM),
    },
    {
      id: 'judgementAddExpertInfo',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_JUDGEMENT_ADD_EXPERT_INFO),
    },
    {
      id: 'claimRejectionReasons',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_CLAIM_REJECTION_REASONS),
    },
    {
      id: 'deceasedVictims',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_DECEASED_VICTIMS),
    },
    {
      id: 'feeNote',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_FEE_NOTE),
    },
    {
      id: 'notification',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_NOTIFICATION),
    },
    {
      id: 'managerOpening',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_MANAGER_OPENING),
    },
    {
      id: 'fraudeCorpo',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_FRAUDE),
    },
    {
      id: 'civilProceeding',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_CIVIL_PROCEEDING),
    },
    {
      id: 'judiciaryManager',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_JUDICIARY_MANAGER),
    },
    {
      id: 'disclaimerWarranty',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_DISCLAIMER_WARRANTY),
    },
    {
      id: 'provision',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_PROVISION),
    },
    {
      id: 'judgementOnMeritsContestation',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_JUDGEMENT_ON_MERITS_CONTESTATION,
      ),
    },
    {
      id: 'addMultipleJudgementAdd',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_ADD_MULTIPLE_JUDGEMENT_ADD,
      ),
    },
    {
      id: 'addLawyerJudiciaryProcess',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_ADD_LAWYER_JUDICIARY_PROCESS,
      ),
    },
    {
      id: 'enableJudiciarySteps',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_ENABLE_JUDICIARY_STEPS),
    },
    {
      id: 'addSupportDocuments',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_ADD_SUPPORT_DOCUMENTS),
    },
    {
      id: 'assignmentClaim',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_ASSIGNMENT_CLAIM),
    },
    {
      id: 'addMultipleJom',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_ADD_MULTIPLE_JOM),
    },
    {
      id: 'expertIntegration',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_EXPERT_INTEGRATION),
    },
    {
      id: 'expertIntegrationAccounting',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_EXPERT_INTEGRATION_ACCOUNTING,
      ),
    },
    {
      id: 'expertIntegrationMechanic',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_EXPERT_INTEGRATION_MECHANIC,
      ),
    },
    {
      id: 'lawyerRejectedClaimUpdate',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_LAWYER_REJECTED_CLAIM_UPDATE,
      ),
    },
    {
      id: 'assignmentManagerTown',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_ASSIGNMENT_MANAGER_TOWN),
    },
    {
      id: 'assignmentMultipleLawyers',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_ASSIGNMENT_MULTIPLE_LAWYERS,
      ),
    },
    {
      id: 'searchClaimByClaimNumber',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_SEARCH_BY_CLAIM_NUMBER),
    },
    {
      id: 'managerLockClaim',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_MANAGER_LOCK_CLAIM),
    },
    {
      id: 'manageClaimByManager',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_MANAGE_CLAIM_BY_MANAGER),
    },
    {
      id: 'updateClaimOpeningManager',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_UPDATE_CLAIM_OPENING_MANAGER,
      ),
    },
    {
      id: 'administrationManager',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_ADMINISTRATION_MANAGER),
    },
    {
      id: 'attributionInboxesManager',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_ATTRIBUTION_INBOXES_MANAGER,
      ),
    },
    {
      id: 'openClaimByOpeningManager',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_OPEN_CLAIM_OPENING_MANAGER,
      ),
    },
    {
      id: 'updateClaimCourtManager',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_UPDATE_CLAIM_COURT_MANAGER,
      ),
    },
    {
      id: 'migrationClaimInfoSagis',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_MIGRATION_CLAIM_INFO_SAGIS,
      ),
    },
    {
      id: 'assignmentJurisdictionLawyer',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_ASSIGNMENT_JURISDICTION_LAWYER,
      ),
    },
    {
      id: 'claimNatureTransaction',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_CLAIM_NATURE_TRANSACTION),
    },
    {
      id: 'fraudInfo',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_FRAUD_INFO),
    },
    {
      id: 'automaticLockClaim',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_AUTOMATIC_LOCK_CLAIM),
    },
    {
      id: 'judgementOnMeritsInfo',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_JUDGEMENT_ON_MERITS_INFO),
    },
    {
      id: 'regulationV2',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_REGULATION_V2),
    },
    {
      id: 'getDahirAmountV2',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_GET_DAHIR_AMOUNT_V2),
    },
    {
      id: 'regulationWorkflowValidation',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_REGULATION_WORKFLOW_VALIDATION,
      ),
    },
    {
      id: 'updateValidatedClaimOpeningManager',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
      ),
    },
    {
      id: 'regulationMaterial',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_REGULATION_MATERIAL),
    },
    {
      id: 'billingInfoFeeNote',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_ADD_BILLING_INFO_FEE_NOTE),
    },
    {
      id: 'reasonsForNonCompensation',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_REASONS_FOR_NON_COMPENSATION,
      ),
    },
    {
      id: 'trackingActionsUser',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_TRACKING_ACTIONS_USER),
    },
    {
      id: 'evolutionsFeeNote',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_EVOLUTIONS_FEE_NOTE),
    },
    {
      id: 'billingInfoFeeNoteExpert',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_BILLING_INFO_FEE_NOTE_EXPERT,
      ),
    },
    {
      id: 'traitementImagineDoc',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_TRAITEMENT_DOC_IMAGINE),
    },
    {
      id: 'basicManagement',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_BASIC_MANAGEMENT),
    },
    {
      id: 'statusManagement',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_STATUS_MANAGEMENT),
    },
    {
      id: 'priorityClaim',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_PRIORITY_CLAIM),
    },
    {
      id: 'displayTrackingIcon',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_DISPLAY_TRACKING),
    },
    {
      id: 'addStakeHolder',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_ADD_STAKE_HOLDER),
    },
    {
      id: 'instructions',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_INSTRUCTIONS),
    },
    {
      id: 'newRecapClaimGo',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_NEW_RECAP_CLAIM_GO),
    },
    {
      id: 'incomeCertificate',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_INCOME_CERTIFICATE),
    },
    {
      id: 'attributionInboxesTransactionManager',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_ATTRIBUTION_INBOXES_TRANSACTION_MANAGER,
      ),
    },
    {
      id: 'transaction',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_TRANSACTION),
    },
    {
      id: 'assignmentJurisdictionLawyerRequest',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_ASSIGNMENT_JURISDICTION_LAWYER_REQUEST,
      ),
    },
    {
      id: 'addCostSagis',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_ADD_COSTS_SAGIS),
    },
    {
      id: 'addCostGpoOpeningClaim',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_ADD_COSTS_GPO_OPENING_CLAIM,
      ),
    },
    {
      id: 'isVictimExcludedFromCoverage',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_IS_VICTIM_EXCLUDED_FROM_COVERAGE,
      ),
    },
    {
      id: 'inboxesTransactionManager',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_INBOXES_TRANSACTION_MANAGER,
      ),
    },
    {
      id: 'addFeeNoteOpeningManager',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_ADD_FEE_NOTE_OPENING_MANAGER,
      ),
    },
    {
      id: 'basicManagementRegulation',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_BASIC_MANAGEMENT_REGULATION,
      ),
    },
    {
      id: 'platformManager',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_PLATFORM_MANAGER),
    },
    {
      id: 'transactionV2',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_TRANSACTION_V2),
    },
    {
      id: 'platformManagerIntervenant',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_PLATFORM_MANAGER_INTERVENANT,
      ),
    },
    {
      id: 'activateEvolutionsP1',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_EVOLUTIONS_P1),
    },
    {
      id: 'activateEvolutionsP3',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_EVOLUTIONS_P3),
    },
    {
      id: 'activateEvolutionsP4',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_EVOLUTIONS_P4),
    },
    {
      id: 'documentumJudiciarySteps',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_DOCUMENTUM_JUDICIARY_STEPS,
      ),
    },
    {
      id: 'lawyerInboxes',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_LAWYER_INBOXES),
    },
    {
      id: 'refactoGetLegalProceeding',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_REFACTO_GET_LEGAL_PROCEEDING,
      ),
    },
    {
      id: 'updateVictimBasicManagement',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_UPDATE_VICTIM_BASIC_MANAGEMENT,
      ),
    },
    {
      id: 'resolveExpertiseReportValues',
      enabled: isEnabled(
        process.env.REACT_APP_FFLIP_RESOLVE_EXPERTISE_REPORT_VALUES,
      ),
    },
    {
      id: 'rnva',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_RNVA),
    },
    {
      id: 'healthCheckPolling',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_HEALTH_CHECK_POLLING),
    },
    {
      id: 'courtCalendar',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_COURT_CALENDAR),
    },
    {
      id: 'limitInvoiceDate',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_LIMIT_INVOICE_DATE),
    },
    {
      id: 'newLawDahir',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_NEW_LAW_DAHIR),
    },
    {
      id: 'gsjOptionalData',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_GSJ_OPTIONAL_DATA),
    },
    {
      id: 'openingByUsage',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_OPENING_BY_USAGE),
    },
    {
      id: 'fusion',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_FUSION),
    },
    {
      id: 'rebrandingEditique',
      enabled: isEnabled(process.env.REACT_APP_FFLIP_REBRANDING_EDITIQUE),
    },
  ],
  reload: 60,
};

export default fflipConfig;
